export default __webpack_public_path__ + "static/En_EFTB_iMedical_Exclusion-4e5a52b4623271b27b2ecdd3928614bb.pdf";